// src/lib/session.js
import axios from '../axiosInstance'; // ggf. Pfad an dein Projekt anpassen

let initDone = false;
let initInFlight = null;

let whoamiCache = null;
let whoamiCacheTS = 0;

/**
 * Initialisiert die Mentoring-Session.
 * - Ruft csrf-token, session und whoami PARALLEL ab
 * - Cacht whoami kurzzeitig
 */
export async function ensureMentoringSession(force = false) {
  const t0 = performance.now();
  console.time('[perf] ensureMentoringSession');

  try {
    if (!force) {
      if (initDone && whoamiCache) return whoamiCache;
      if (initInFlight) return initInFlight; // concurrent dedupe
    }

    initInFlight = (async () => {
      const [csrfRes, sessionRes, whoamiRes] = await Promise.all([
        axios.get('/csrf-token', { withCredentials: true }),
        axios.get('/session',     { withCredentials: true }),
        axios.get('/mentoring/whoami', { withCredentials: true }),
      ]);

      whoamiCache  = whoamiRes?.data ?? null;
      whoamiCacheTS = Date.now();
      initDone = true;
      return whoamiCache;
    })();

    try {
      return await initInFlight;
    } finally {
      initInFlight = null; // nach Abschluss wieder freigeben
    }
  } finally {
    console.timeEnd('[perf] ensureMentoringSession');
    const dt = performance.now() - t0;
    console.log('[perf] ensureMentoringSession total(ms)=', Math.round(dt));
  }
}

/** Gibt den gecachten whoami zurück, wenn jünger als maxAgeMs */
export function getCachedWhoami(maxAgeMs = 5 * 60 * 1000) {
  if (whoamiCache && Date.now() - whoamiCacheTS < maxAgeMs) {
    return whoamiCache;
  }
  return null;
}

/** Optional: Cache leeren (z. B. beim Logout) */
export function clearSessionCache() {
  initDone = false;
  initInFlight = null;
  whoamiCache = null;
  whoamiCacheTS = 0;
}

